var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServer = function SvgServer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2149_2218)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2149_2218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2149_2218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4585 3.20996H5.54183C4.25317 3.20996 3.2085 4.25463 3.2085 5.54329V9.62663C3.2085 10.9153 4.25317 11.96 5.54183 11.96H22.4585C23.7472 11.96 24.7918 10.9153 24.7918 9.62663V5.54329C24.7918 4.25463 23.7472 3.20996 22.4585 3.20996Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29183 9.04264C8.09724 9.04264 8.75016 8.38973 8.75016 7.58431C8.75016 6.77889 8.09724 6.12598 7.29183 6.12598C6.48641 6.12598 5.8335 6.77889 5.8335 7.58431C5.8335 8.38973 6.48641 9.04264 7.29183 9.04264Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9583 9.04264C12.7637 9.04264 13.4167 8.38973 13.4167 7.58431C13.4167 6.77889 12.7637 6.12598 11.9583 6.12598C11.1529 6.12598 10.5 6.77889 10.5 7.58431C10.5 8.38973 11.1529 9.04264 11.9583 9.04264Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5835 16.04H5.54183C4.25316 16.04 3.2085 17.0847 3.2085 18.3734V22.4567C3.2085 23.7454 4.25316 24.79 5.54183 24.79H14.5835C15.8722 24.79 16.3335 23.7454 16.3335 22.4567V18.3734C16.3335 17.0847 15.8722 16.04 14.5835 16.04Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29183 21.8737C8.09724 21.8737 8.75016 21.2208 8.75016 20.4154C8.75016 19.6099 8.09724 18.957 7.29183 18.957C6.48641 18.957 5.8335 19.6099 5.8335 20.4154C5.8335 21.2208 6.48641 21.8737 7.29183 21.8737Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9583 21.8737C12.7637 21.8737 13.4167 21.2208 13.4167 20.4154C13.4167 19.6099 12.7637 18.957 11.9583 18.957C11.1529 18.957 10.5 19.6099 10.5 20.4154C10.5 21.2208 11.1529 21.8737 11.9583 21.8737Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 17.5H24.4998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 19.833H24.4998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 22.167H24.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2149_2218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor"
  })))));
};
export default SvgServer;